import LineDot from './LineDot';

export default function Section({ title, subtext, children, className = '' }) {
  return (
    <section className={`py-10 sm:py-12 ${className}`}>
      <div className="flex items-center gap-3 mb-6">
        <h2 className="text-xl sm:text-2xl font-semibold font-heading tracking-wide whitespace-nowrap">{title}</h2>
        <LineDot width="fill" />
      </div>

      {subtext ? (
        <p className="text-lg sm:text-xl md:text-2xl text-black-muted dark:text-white-muted mb-8 fade-up pb-8">
          {subtext}
        </p>
      ) : null}

      <div className="space-y-8">
        {children}
      </div>
    </section>
  );
}
